export const hasAuthPermission = (user: any, permissionName: string) => {
  const matched = user?.role?.role?.permissions?.find((permission: string) => permission === permissionName)
  if (matched === undefined) return false
  return true
}
